// extracted by mini-css-extract-plugin
module.exports = {"tagsInput":"_3CuDB6","form-textarea":"y7R0lD","form-select":"_1_204g","form-multiselect":"_1CZoHI","form":"f2omcM"};